import { readable } from 'svelte/store';

let globaldata = window.globalSiteData;

let { subscribe } = readable(globaldata);

export default {
    subscribe
}

